import feelPopup from './FeelPopupModule';

export default {
  feelPopup: [ 'type', feelPopup ]
};
